import Request from '../Request.utils'
export interface ISubmitEnquiryRequestBody {
  accountNumber?: string;
  attendees?: string;
  company: string;
  email: string;
  enquiryType: string;
  firstName: string;
  lastName: string;
  message: string;
  orderNumber?: string;
  preferredLocation?: string;
  privacyConsent: true;
  productOrEquipment?: string;
  siteLocation?: string;
  source?: string;
  telephone?: string;
  trainingFormat?: string;
  trainingRequirements?: string;
}


class ContactAPI {
  submitEnquiry = async (body: ISubmitEnquiryRequestBody) => {
    const res = await Request.call('/api/contact/enquiry', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new ContactAPI()